<template>
  <router-view />
</template>

<script>
export default {
  name: 'MachinesWrapper',
};
</script>
